import { createFileRoute } from "@tanstack/react-router"

import { requireSuperAdminRouteAccess } from "@/features/authz/require-super-admin-route-access"
import { StaffNotificationRoutingPage } from "@/features/settings/components/staff-notification-routing-page"

export const Route = createFileRoute("/dashboard/settings/staff-notifications")({
	component: StaffNotificationRoutingPage,
	beforeLoad: async ({ context }) => await requireSuperAdminRouteAccess(context.queryClient),
})
